import * as React from "react";
import { SVGProps } from "react";
const SvgSocialTwitter = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M26.295 10.472v.723C26.295 18.51 20.695 27 10.49 27c-2.98 0-5.961-.903-8.49-2.529a11.15 11.15 0 0 0 8.219-2.258c-2.348 0-4.426-1.625-5.239-3.883.813.18 1.716.09 2.53-.09a5.507 5.507 0 0 1-4.421-5.182l-.005-.328c.813.452 1.625.632 2.529.723-2.439-1.626-3.161-4.877-1.716-7.406 2.8 3.432 6.954 5.6 11.47 5.78-.723-2.98 1.174-5.96 4.154-6.683 1.897-.452 3.974.18 5.329 1.625a11.883 11.883 0 0 0 3.522-1.354c-.451 1.264-1.264 2.348-2.438 3.07 1.083-.18 2.167-.451 3.16-.903-.65.976-1.52 1.878-2.477 2.641l-.322.25v-.001Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgSocialTwitter;
